import { orchestrator } from 'satcheljs';
import { removedConnectedAccountIdCleanup } from 'owa-calendar-account-store';
import setErrorDialogState from '../mutators/setErrorDialogState';
import { CalendarAccountErrorDialogState } from '../schema/CalendarAccountErrorDialogState';

orchestrator(removedConnectedAccountIdCleanup, () => {
    setErrorDialogState(false, CalendarAccountErrorDialogState.RemovedCalendarIds);
});
